import { Pages, NavigationFunction as RootNavigation } from "../Navigation/Routers/root"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import "../Translations/index"
import { ButtonList } from "../Components"
import { css, icons } from "../Styles/index"
import { ListStyle_Types } from "../Definitions"


export default function Def() {
  const navigator = useNavigate()
  const {t} = useTranslation()
  
  const BtnFunc_Router = (btn_index: number) => {
    console.log("btn_index", btn_index)
    switch (btn_index) {
      case 0: 
        RootNavigation(navigator, Pages.kpi)
        break
      case 1:
        RootNavigation(navigator, Pages.op_operations)
        break
      default:
        alert("Error ???")
    }
  }

  return (
    <div>
      <ButtonList 
        contents={[t("loginFlow.def.cloudView", {defaultValue: "cloud view"}), t("loginFlow.def.operationsView", {defaultValue: "operations view"})]}
        onClick={(e) => BtnFunc_Router(e)}
        startEnhancers={[icons.platformDesktop, icons.platformOperation]}
        overrides={{
          baseButton: {justifyContent: "start"},
          contentStyles: {textAlign: "left"}
        }}
        listOverrides={{
          listStyle: ListStyle_Types.vertical
        }}
      />
    </div>  
  )
} 
